import React, { useState, useEffect } from 'react';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';

import { useTranslation } from '../../context/TranslationContext';
import soundManager from '../../utils/SoundManager';

import {
  HeaderPillButton,
  HeaderToggleRow,
  HeaderRowLabelGroup,
  HeaderRowLabel,
  HeaderRowSwitch,
  headerRowIconSx,
} from './styles';

const SoundControl = ({ variant = 'pill', sx }) => {
  const [soundEnabled, setSoundEnabled] = useState(soundManager.enabled);
  const { translate } = useTranslation();

  useEffect(() => {
    soundEnabled ? soundManager.enable() : soundManager.disable();
  }, [soundEnabled]);

  const handleToggle = () => {
    setSoundEnabled((prev) => !prev);
  };
  const Icon = soundEnabled ? VolumeUpIcon : VolumeOffIcon;

  if (variant === 'row') {
    return (
      <HeaderToggleRow component="label" sx={sx}>
        <HeaderRowLabelGroup>
          <Icon sx={headerRowIconSx} />
          <HeaderRowLabel>{translate('header.Sound')}</HeaderRowLabel>
        </HeaderRowLabelGroup>
        <HeaderRowSwitch
          checked={soundEnabled}
          onChange={handleToggle}
          slotProps={{
            input: {
              'aria-label': translate(soundEnabled ? 'header.SoundOn' : 'header.SoundOff'),
            },
          }}
          disableRipple
        />
      </HeaderToggleRow>
    );
  }

  return (
    <HeaderPillButton
      type="button"
      aria-label={translate(soundEnabled ? 'header.SoundOn' : 'header.SoundOff')}
      onClick={handleToggle}
      startIcon={<Icon />}
      sx={sx}
    >
      {translate(soundEnabled ? 'header.On' : 'header.Off')}
    </HeaderPillButton>
  );
};

export default SoundControl;
